<template>
  <div
    v-if="visible"
    class="fixed-bottom d-flex justify-content-center p-3 mb-3 z-index-sticky"
  >
    <div
      :ref="setRef"
      class="d-flex flex-wrap align-items-center rounded-lg bg-white text-default border batch-custom position-relative py-3 pl-4 pr-3"
      role="region"
      aria-label="Seleção em lote"
    >
      <span aria-live="polite" class="mr-3 flex-shrink-0 fit-max-content">
        <span
          class="text-sm bg-exitos px-3 py-1 text-white rounded-pill mr-2"
          v-text="count"
        />
        <span class="text-muted text-sm" v-text="label" />
      </span>

      <div class="flex-grow-1 d-inline-flex align-items-center mr-3">
        <slot :ids="selectedIds" :count="count" />
      </div>

      <div class="d-flex align-items-center">
        <b-button
          variant="outline-exitos"
          class="mr-2 rounded-sm"
          :disabled="busy"
          @click="cancel"
        >
          {{ cancelLabel }}
        </b-button>
        <b-button
          v-if="!hiddenConfirm"
          variant="exitos"
          class="rounded-sm"
          :disabled="confirmDisabled || busy"
          @click="confirm"
        >
          <b-spinner v-if="busy" small class="mr-1 custom-spinner" />
          {{ confirmLabel }}
        </b-button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { safeArray } from "@/helpers/functions/ArrayHelpers";
import { computed } from "vue";

const props = defineProps({
  value: {
    type: Array,
    default: () => [],
  },
  visible: {
    type: Boolean,
    default: false,
  },
  cancelLabel: {
    type: String,
    default: "Cancelar",
  },
  confirmLabel: {
    type: String,
    default: "Confirmar",
  },
  confirmDisabled: {
    type: Boolean,
    default: false,
  },
  hiddenConfirm: {
    type: Boolean,
    default: false,
  },
  busy: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits([
  "cancel",
  "confirm",
  "update:visible",
  "get-pannel-ref",
]);

const count = computed(() => safeArray(props.value).length);
const selectedIds = computed(() => [...props.value]);

const label = computed(() =>
  count.value === 1 ? "Selecionado" : "Selecionados"
);

function setRef($ref) {
  emit("get-pannel-ref", $ref);
}

function cancel() {
  emit("update:visible", false);
  emit("cancel");
}

function confirm() {
  if (props.confirmDisabled || props.busy) return;
  emit("confirm", [...selectedIds.value]);
}
</script>
<style scoped lang="scss">
.batch-custom {
  box-shadow: 0.5rem 0.75rem 1rem rgba(var(--dark-rgb), 0.25) !important;

  .custom-spinner {
    width: 1rem;
    height: 1rem;
    border-width: 2px;
  }

  .fit-max-content {
    min-width: 117px;
  }
}

.z-index-sticky {
  z-index: 999;
}
</style>
